import React from 'react'

import { ToggleButton as UIToggleButton } from '@carsys/ui'

type UIToggleButtonProps = React.ComponentProps<typeof UIToggleButton>

export function ToggleButton({ children, ...props }: UIToggleButtonProps) {
  return <UIToggleButton {...props}>{children}</UIToggleButton>
}
